export const postContentClass = "Content"
export const hasFocusClass = "ProseMirror-selectednode"
export const hideSelectionClass = "ProseMirror-hideselection"
export const editableSelector = `[contenteditable="true"]`

export const zoomOverlayClass = "fika-zoom-overlay"
export const zoomWrapperClass = "fika-zoom-wrapper"
export const zoomImgClass = "fika-zoom-img"
export const zoomCaptionClass = "fika-zoom-caption"
